// The host object addons are booted with. Factory-owned.
//
// The 0.1 chassis had an `App` class, and addons extend it by writing onto
// `app.constructor.prototype` — that is how `sharelinks` adds
// `openSharedPayload` and `notifications` adds `notifyOwner`, so that anything
// holding the app can call them.
//
// Vue has no such class, and inventing a different contract would mean
// rewriting every addon for the new chassis and again for the one after that.
// A plugin surface that changes with the renderer is not a plugin surface. So
// this is a real class with a real prototype, and the existing pattern keeps
// working unchanged.
//
// What it is NOT is a place to put your app. Your app is src/App.vue and the
// components around it; this exists so addons have somewhere stable to attach.

import { bus, state } from './state.js';

class AppHost {
  /**
   * Is now a bad moment to reload?
   *
   * Both update paths ask — the service worker and the OTA bundle — so
   * overriding this once covers both. Return true while the user is mid-edit
   * and a reload would throw work away.
   */
  isIdle() { return true; }

  /** Handle a URL, from a cold start or a native deep link. */
  route(url) { bus.emit('route', url); }

  get state() { return state; }
  get bus() { return bus; }
}

export const app = new AppHost();
